import { useMemo } from "react";
import {StackedChart} from "./base/StackedChart";
import useAppContext from "../../hooks/useAppContext";

export const CheckoutsRecoverableVsRecovered = () => {
    const { data: { checkoutRecoverableVsRecovered } } = useAppContext();
    const isDataLoaded = useMemo(() => !!checkoutRecoverableVsRecovered.data?.length, [checkoutRecoverableVsRecovered.data?.length]);

    if(!checkoutRecoverableVsRecovered.data?.length) return null;

    const labels = checkoutRecoverableVsRecovered.data?.map((row: any) => row.date);
    const dataSets = [
        {label: 'Recovered Checkouts', values: checkoutRecoverableVsRecovered.data?.map((row: any) => row.recovered)},
        {label: 'Abandoned Checkouts', values: checkoutRecoverableVsRecovered.data?.map((row: any) => row.recoverable), isNegative: true}
    ];

    return <StackedChart
        labels={labels}
        dataSets={dataSets}
        data={checkoutRecoverableVsRecovered}
        title="Abandoned VS Recovered Checkouts"
        isDataLoaded={isDataLoaded}
    />
}